export enum MessageConst {
    SUCCESS="SUCCESS",
    CURRENT_URL_SUMMARY_PAGE="currentUrlSummaryPage"
}